<template>
  <section>
    <div class="row">
      <div class="col-lg-6 col-12 p-0 p-sm-2">
        <div class="mb-4">
          <img src="https://beneat.co/images/pdpa00.jpg" alt="" class="img-fluid rounded">
        </div>
        <h4>{{ $t('message.personal_data_management.title') }}</h4>
        <div class="pb-2 text-small">
          <div class="pt-2">{{ $t('message.personal_data_management.detail01') }}</div>
          <div class="pt-3" v-html="$t('message.personal_data_management.detail02')"></div>
          <div class="pt-3" v-if="personalTopics">
            <ul class="list-unstyled" style="line-height: 1.5rem;">
              <template v-for="(personalTopic, index) in personalTopics">
                <li>{{ index + 1 }}. {{ $i18n.locale === 'th' ? personalTopic.title_th : personalTopic.title_en }}</li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 p-0 p-sm-2">
        <section v-if="personalTopics && userPersonalTopics">
          <div class="card mt-0" v-for="(personalTopic, index) in personalTopics" :key="index">
            <img class="card-img-top" :src="personalTopic.image_url" :alt="personalTopic.title_th">
            <div class="card-body">
              <h4>{{ $i18n.locale === 'th' ? personalTopic.title_th : personalTopic.title_en }}</h4>
              <div class="text-small">
                <span v-if="isShortText[index]"
                      v-html="$options.filters.shortText($i18n.locale === 'th' ? personalTopic.content_th : personalTopic.content_en, 80)"
                      v-linkified></span>
                <span v-linkified
                      v-html="$i18n.locale === 'th' ? personalTopic.content_th : personalTopic.content_en"
                      v-else>
                </span>
                <label @click="setIsShortText(index, false)"
                       v-if="isShortText[index]">
                  {{ $t('message.personal_data_management.read_more') }}
                </label>
              </div>
              <hr>
              <div class="row no-gutters">
                <div class="col-6">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input class="form-check-input"
                             type="radio"
                             :name="'personalTopic' + personalTopic.id"
                             v-model="userPersonalTopics[index].status"
                             @change="setStatus(index, 1)"
                             :value="1">
                      {{ $t('message.personal_data_management.accept') }}
                    </label>
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-check">
                    <label class="form-check-label">
                      <input class="form-check-input"
                             type="radio"
                             :name="'personalTopic' + personalTopic.id"
                             v-model="userPersonalTopics[index].status"
                             @change="setStatus(index, 0)"
                             :value="0">
                      {{ $t('message.personal_data_management.decline') }}
                    </label>
                  </div>
                </div>
              </div>
              <div class="-status-alert text-small pt-2"
                   v-if="userPersonalTopics[index].status === 0 && personalTopic.can_decline === 0">
                {{ $t('message.personal_data_management.alert_message') }}
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <div class="mt-2">
      <button class="btn btn-block btn-lg"
              :class="canSubmit ? 'btn-info' : 'btn-secondary'"
              :disabled="!canSubmit"
              @click="saveUserPersonalTopics()">
        {{ isLoading ? $t('message.button.loading') : $t('message.button.submit') }}
      </button>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        personalTopics: null,
        userPersonalTopics: null,
        canSubmit: false,
        isLoading: false,
        picked: null,
        isShortText: []
      }
    },
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      }),
      content () {
        return this.$i18n.locale === 'th' ? this.personalTopic.content_th : this.personalTopic.content_en
      }
    },
    methods: {
      setStatus (index, status) {
        this.userPersonalTopics[index].status = status
        this.userPersonalTopics = [...this.userPersonalTopics]
        this.checkValidation()
      },
      setIsShortText (index, status) {
        this.isShortText[index] = status
        this.isShortText = [...this.isShortText]
      },
      checkValidation () {
        let count = 0
        for (let key in this.personalTopics) {
          if (this.userPersonalTopics[key].status === null) {
            count += 1
          }

          if (this.personalTopics[key].can_decline === 0 && this.userPersonalTopics[key].status === 0) {
            count += 1
          }
        }
        this.canSubmit = (count === 0)
      },
      async fetchPersonalTopics () {
        const url = '/user-personal-topics'
        const params = {
          user_id: this.user.id,
          include_can_decline: true
        }
        const res = await axios.get(url, {params})
        if (res.status === 200) {
          const response = res.data
          this.personalTopics = response.personal_topics
          if (response.user_personal_topics) {
            this.userPersonalTopics = response.user_personal_topics
          } else {
            this.userPersonalTopics = []
            for (let key in this.personalTopics) {
              const personalTopic = this.personalTopics[key]
              this.userPersonalTopics[key] = {
                user_id: this.user.id,
                personal_topic_id: personalTopic.id,
                status: null
              }
            }
          }
          for (let index in this.userPersonalTopics) {
            this.isShortText[index] = true
          }
          this.checkValidation()
        }
      },
      async saveUserPersonalTopics () {
        this.isLoading = true
        const url = '/user-personal-topics'
        const submitData = {
          user_personal_topics: this.userPersonalTopics
        }
        const res = await axios.post(url, submitData)
        this.isLoading = false
        if (res.status === 200) {
          const response = res.data
          console.log('check response', response)
          this.$emit('saved', true)
        }
      }
    },
    mounted () {
      this.fetchPersonalTopics()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/privacy/ConfirmPersonalTopic.vue